var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAddContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 17.4993C21.5268 17.4993 24.7913 14.2348 24.7913 10.2077C24.7913 6.18061 21.5268 2.91602 17.4997 2.91602C13.4726 2.91602 10.208 6.18061 10.208 10.2077C10.208 14.2348 13.4726 17.4993 17.4997 17.4993Z",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97266 32.0833C4.97266 26.4396 10.5872 21.875 17.4997 21.875C18.8997 21.875 20.256 22.0646 21.5247 22.4146",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0837 26.2493C32.0837 26.716 32.0253 27.1681 31.9087 27.6056C31.7774 28.1889 31.5441 28.7577 31.2378 29.2535C30.2316 30.9452 28.3795 32.0827 26.2503 32.0827C24.7482 32.0827 23.392 31.5139 22.3712 30.5806C21.9337 30.2014 21.5545 29.7493 21.2628 29.2535C20.7232 28.3785 20.417 27.3431 20.417 26.2493C20.417 24.6743 21.0441 23.2306 22.0649 22.1806C23.1295 21.0869 24.617 20.416 26.2503 20.416C27.9712 20.416 29.5316 21.1598 30.5816 22.3556C31.5149 23.391 32.0837 24.7618 32.0837 26.2493Z",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.423 26.2207H24.0771",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 24.0918V28.4522",
    stroke: "#00ACB9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddContact);
export default __webpack_public_path__ + "static/media/user_add_contact.096134876e376d441cb5efac4022de08.svg";
export { ForwardRef as ReactComponent };